export default "__VITE_ASSET__e4GOJcHJ__"